module.exports = __webpack_public_path__ + "static/media/forbidden_img.3c600185.svg";